import { type QuizQuestion, QuizQuestionType } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { Type } from '@warp-drive/core/types/symbols';

import { MetaQuestionEditorComponent } from '../editors/question/meta.gts';
import type { QuestionManager } from '../types/question-manager';

export const MetaQuestionManager: QuestionManager = {
  discriminator: (question: QuizQuestion) =>
    question.type === QuizQuestionType.Meta,
  type: QuizQuestionType.Meta,
  icon: 'ph:info',
  editingIcon: 'ph:file-dotted',
  editingLabel: 'Page Break',
  label: 'Information',
  questionComponent: MetaQuestionEditorComponent,
  scoringComponent: null,
  responseComponent: null,
  reportingComponent: null,
  defaultData: {
    reporting: {
      [Type]: DataTypeQuiz.QuizReportingQuestion,
      groupName: '',
      questionName: '',
    },
  },
};
